import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from 'src/app/services/preferences.service';
import { AuthService } from 'src/app/services/auth.service';
declare var $ : any;
@Component({
  selector: 'app-life-goals-list',
  templateUrl: './life-goals-list.component.html',
  styleUrls: ['./life-goals-list.component.css']
})
export class LifeGoalsListComponent implements OnInit {
  token: any;
  lifeGoalsList: any;
  p: any = 1;
  count: any = 0;
  total: any = 10;
  id: any;
  searchText: any = '';
  sideStatus: any;
  isChecked: any;
  religionId: any = [];
  masterSelected: boolean = false;
  exportList: any;
  constructor(    public router: Router,
    private prefrencesService: PreferencesService,
    private toastr : ToastrService,
    private authService: AuthService,
    private activateroute: ActivatedRoute) { }

  public get isManager(): boolean {
    return this.authService.isManager;
  }

  ngOnInit(): void {
    this.lifeGoalListing();
  }

  lifeGoalListing() {
    let offset = this.p - 1;
    if(this.searchText != '')
    {
      offset = 0;
    }
    let obj = {
      limit: 10,
      offset: offset,
      search: this.searchText,
    };
    this.token = localStorage['token'];
    this.prefrencesService.getLifeGoals(obj,this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.lifeGoalsList =  res.data.data;
        this.count = res.data.total_count;
      }
      else if (res.status == 400 && res.message == "Please provide valid token") {
        this.toastr.error(res.message);
        this.router.navigate(['/login']);
      }
      else{
        this.toastr.success(res.message);
        alert(res.message);
      }
    });
  }

  checkSearchString() {
    if (!this.searchText) {
      // return this.stopSearchLoader();
    }
    this.lifeGoalListing()
   }

   stopSearchLoader() {
    $('.lds-ring').css('display', 'none');
  }

  searchTextFilter() {
    this.lifeGoalListing()
  }

  onTableDataChange(event: any) {
    this.p = event;
    this.masterSelected = false;
    this.religionId = [];
    this.lifeGoalListing();
  }

  openModal(item: any){
    this.id = item.id;
  }

  deletePop(){
    let obj = {
      id: this.id,
    };
    console.log(obj)
    this.prefrencesService
      .deleteLifeGoals(obj, this.token)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.toastr.success(res.message);
          $('#deletModal').modal('hide');
        } else if (res.status == 500) {
          this.toastr.success(res.message);
        }
        this.lifeGoalListing();
      });
  }
}
